'use client'

import { useTranslations } from 'next-intl'
import { useState } from 'react'

import { Button } from '../../../../../components/Button'
import { FormattedContent } from '../../../../../components/FormattedContent'
import { CustomWrapperComponent } from '../../../../../components/FormattedContent/HTMLWrapper'
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '../../../../../components/Sheet'
import { WithdrawButton } from '../WithdrawButton'

interface Props {
  onConfirm: () => void
  isLoading: boolean
  isError: boolean
  withdrawalRequestInformation?: string | null
}

function RequestWithdrawalSheet({ onConfirm, isLoading, isError, withdrawalRequestInformation }: Props) {
  const [isOpen, setIsOpen] = useState(false)
  const translate = useTranslations('product-details')

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <WithdrawButton onClick={() => setIsOpen(true)} />
      </SheetTrigger>
      <SheetContent
        side="bottom"
        className="flex max-h-screen flex-col gap-2 overflow-y-auto p-6"
        aria-describedby={undefined}
      >
        <SheetTitle>{translate('withdraw-overlay-title')}</SheetTitle>
        <p className="text-sm text-text-secondary">{translate('withdraw-overlay-description')}</p>
        {withdrawalRequestInformation && (
          <FormattedContent htmlContent={withdrawalRequestInformation} WrapperComponent={CustomWrapperComponent} />
        )}
        {isError && <p className="text-sm text-text-error">{translate('withdraw-error')}</p>}
        <div className="flex flex-col gap-3 pt-4">
          <Button
            variant={isLoading ? 'loading-brand-primary' : 'brand-primary'}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {translate('withdraw-overlay-confirm')}
          </Button>
          <Button variant="outline" onClick={() => setIsOpen(false)} disabled={isLoading}>
            {translate('withdraw-overlay-cancel')}
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  )
}

export { RequestWithdrawalSheet }
